<template>
    <section class="section">
        <div class="container is-max-widescreen is-max-desktop">
            <h1 class="title has-text-centered">
                Export par filtres
            </h1>
            <b-notification type="is-info" aria-close-label="Close notification">
                Attention, uniquement les projets complets peuvent être exportés.
            </b-notification>

            <div class="columns">
                <div class="column is-two-thirds">

                    <b-field grouped>

                        <b-field label="Année">
                            <b-select
                                v-model="yearInput"
                                placeholder="Sélectionner">
                                <option
                                    v-for="option in Refyears"
                                    :value="option"
                                    :key="option">
                                    {{ option }}
                                </option>
                            </b-select>
                        </b-field>

                        <b-field label="Type">
                            <b-select
                                v-model="typeInput"
                                placeholder="Sélectionner">
                                <option
                                    v-for="option in Reftype"
                                    :value="option"
                                    :key="option">
                                    {{ option }}
                                </option>
                            </b-select>
                        </b-field>

                        <b-field label="Phase">
                            <b-select
                                v-model="phaseInput"
                                placeholder="Sélectionner">
                                <option
                                    v-for="option in Refphase"
                                    :value="option"
                                    :key="option">
                                    {{ option }}
                                </option>
                            </b-select>
                        </b-field>

                    </b-field>

                    <b-field grouped>

                        <b-field label="Dispositif">
                            <b-select
                                v-model="dispositifInput"
                                placeholder="Sélectionner">
                                <option
                                    v-for="option in RefDispositif"
                                    :value="option"
                                    :key="option">
                                    {{ option }}
                                </option>
                            </b-select>
                        </b-field>

                        <b-field label="Responsable">
                            <b-select
                                v-model="responsableInput"
                                placeholder="Sélectionner">
                                <option
                                    v-for="option in refResponsables"
                                    :value="option"
                                    :key="option">
                                    {{ option }}
                                </option>
                            </b-select>
                        </b-field>

                        <b-field label="Dossier">
                            <b-select
                                v-model="folderInput"
                                placeholder="Sélectionner">
                                <option
                                    v-for="option in refFolders"
                                    :value="option"
                                    :key="option">
                                    {{ option }}
                                </option>
                            </b-select>
                        </b-field>

                    </b-field>

                    <b-field label="Financeur">
                        <b-autocomplete
                            v-model="financeurInputSearch"
                            placeholder="Nom du financeur"
                            keep-first
                            :data="filteredDataObj"
                            field="name"
                            open-on-focus
                            @select="option => (financeurInput = option)"
                            clearable>
                            <template slot-scope="props">
                                <div class="media-content">
                                    {{ props.option }}
                                </div>
                            </template>

                        </b-autocomplete>
                    </b-field>
                </div>
                <div class="column is-one-third">
                    <b-field label="Départements (sélection multiple possible, avec Control + Clic)">
                        <b-select
                            multiple
                            native-size="8"
                            v-model="departementInput"
                            placeholder="Sélectionner">
                            <option
                                v-for="option in RefDepartement"
                                :value="option.value"
                                :key="option.value">
                                {{ option.lab }}
                            </option>
                        </b-select>
                    </b-field>
                </div>
            </div>

            <div class="buttons">
                <b-button
                    type="is-success"
                    @click="search()">
                    Lancer la recherche
                </b-button>
                <b-button
                    :disabled="!dataTable.length > 0"
                    type="is-info"
                    @click="getArchive()">
                    Télécharger l'archive des PDF
                </b-button>
                <b-button
                    :disabled="!dataTable.length > 0"
                    type="is-info"
                    @click="getSpreadSheet()">
                    Télécharger le classeur consolidé
                </b-button>
                <b-button
                    type="is-warning"
                    @click="reset()">
                    Réinitialiser les filtres
                </b-button>
                <b-button
                    type="is-info"
                    @click="sst()">
                    Exporter la sous-traitance
                </b-button>
            </div>

        </div>

        <hr>

        <b-table
            v-if="dataTable.length > 0"
            :data="dataTable"
            bordered
            striped
            hoverable>


            <b-table-column field="PDF" label="PDF" v-slot="props">
                <b-button
                    type="is-primary"
                    icon-right="file"
                    size="is-small"
                    @click.prevent="generatePDF(props.row.id, props.row.id, 'pdf')">
                </b-button>
            </b-table-column>

            <b-table-column field="Tableur" label="Tableur" v-slot="props">
                <b-button
                    type="is-info"
                    icon-right="file-excel"
                    size="is-small"
                    @click.prevent="generatePDF(props.row.id, props.row.id, 'xls')">
                </b-button>
            </b-table-column>

            <b-table-column field="id" label="Identifiant" v-slot="props">
                {{ props.row.id }}
            </b-table-column>

            <b-table-column field="year" label="Année" v-slot="props">
                {{ props.row.value.year }}
            </b-table-column>

            <b-table-column field="phase" label="Phase" v-slot="props">
                {{ props.row.key }}
            </b-table-column>

            <b-table-column field="type" label="Type" v-slot="props">
                {{ props.row.value.type }}
            </b-table-column>

        </b-table>


    </section>

</template>

<script>
export default {
    name: "Export",
    mounted() {
        // Load ref
        this.getRef();
    },
    computed: {
        filteredDataObj() {
            return this.refFI.filter(option => {
                return (
                    option
                        .toString()
                        .toLowerCase()
                        .indexOf(this.financeurInputSearch.toLowerCase()) >= 0
                )
            })
        }
    },
    methods: {
        getRef() {

            this.$axios.get(`ref/folders`)
                .then(function (response) {
                    this.refFolders = response.data.body.dossiers
                }.bind(this))
                .catch(error => {
                    console.log(error);
                });

            this.$axios.get('ref/financeurs')
                .then(function (response) {
                    this.refFI = response.data.financeurs;
                }.bind(this))
                .catch(error => console.log(error));
            this.$axios.get('ref/ids')
                .then(function (response) {
                    // console.log(response.data.ids)
                    this.refResponsables = response.data.ids;
                }.bind(this))
                .catch(error => console.log(error));
            this.$axios.get('ref/project', {})
                .then((res) => {
                    // console.log(res.data)
                    this.RefDispositif = [...res.data.project.ref.prestation, ...res.data.project.ref.subvention];
                    this.RefDispositif = this.RefDispositif.filter((v, i, a) => a.indexOf(v) === i);
                    this.Refphase = res.data.project.ref.phase;
                    this.Refyears = res.data.project.ref.years;
                })

        },
        generatePDF(id, nom, type) {
            this.$axios.get(`pdf?id=${id}&type=${type}&comments=true`,
                {
                    responseType: 'arraybuffer',
                    headers: {
                        'Accept': 'application/pdf'
                    }
                })
                .then(function (response) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${nom}.${type}`); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                }.bind(this))
                .catch(error => console.log(error));
        },
        reset() {
            this.typeInput = '';
            this.folderInput = '';
            this.departementInput = [];
            this.yearInput = '';
            this.phaseInput = '';
            this.financeurInput = '';
            this.dispositifInput = '';
            this.financeurInput = '';
            this.responsableInput = '';
            this.financeurInputSearch = '';
            this.dataTable = [];
        },
        search() {
            this.financeurInput = this.financeurInput === null ? '' : this.financeurInput;
            this.$axios.get(
                `export?archive=false&spreadsheet=false&` +
                `type=${this.typeInput}&` +
                `year=${this.yearInput}&` +
                `phase=${this.phaseInput}&` +
                `financeur=${this.financeurInput}&` +
                `departements=${JSON.stringify(this.departementInput)}&` +
                `dispositif=${this.dispositifInput}&` +
                `responsable=${this.responsableInput}&` +
                `folder=${this.folderInput}&`
            )
                .then(function (response) {
                    // console.log(response.data)
                    this.dataTable = response.data;
                }.bind(this))
                .catch(error => console.log(error));
        },
        getArchive() {
            const loadingComponent = this.$buefy.loading.open({
                container: null
            })
            this.financeurInput = this.financeurInput === null ? '' : this.financeurInput;
            this.$axios.get(
                `export?archive=true&spreadsheet=false&` +
                `type=${this.typeInput}&` +
                `year=${this.yearInput}&` +
                `phase=${this.phaseInput}&` +
                `financeur=${this.financeurInput}&` +
                `departements=${JSON.stringify(this.departementInput)}&` +
                `dispositif=${this.dispositifInput}&` +
                `responsable=${this.responsableInput}&` +
                `folder=${this.folderInput}&` +
                `comments=true`,
                {
                    responseType: 'arraybuffer',
                    headers: {
                        'Accept': 'application/zip'
                    }
                })
                .then(function (response) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${this.typeInput}-${this.yearInput}-${this.phaseInput}.zip`); //or any other extension
                    document.body.appendChild(link);
                    loadingComponent.close();
                    link.click();
                }.bind(this))
                .catch(error => console.log(error));
        },
        getSpreadSheet() {
            const loadingComponent = this.$buefy.loading.open({
                container: null
            })
            this.financeurInput = this.financeurInput === null ? '' : this.financeurInput;
            this.$axios.get(
                `export?archive=false&spreadsheet=true&` +
                `type=${this.typeInput}&` +
                `year=${this.yearInput}&` +
                `phase=${this.phaseInput}&` +
                `financeur=${this.financeurInput}&` +
                `departements=${JSON.stringify(this.departementInput)}&` +
                `dispositif=${this.dispositifInput}&` +
                `responsable=${this.responsableInput}&` +
                `folder=${this.folderInput}&` ,
                {
                    responseType: 'arraybuffer',
                    headers: {
                        'Accept': 'application/vnd.openxmlformats'
                    }
                })
                .then(function (response) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${this.typeInput}-${this.yearInput}-${this.phaseInput}.xlsx`); //or any other extension
                    document.body.appendChild(link);
                    loadingComponent.close();
                    link.click();
                }.bind(this))
                .catch(error => console.log(error));
        },
        async sst() {
            try {
                let r = await this.$axios.get('typologietravaux',
                    {
                        responseType: 'arraybuffer',
                        headers: {
                            'Accept': 'application/vnd.openxmlformats'
                        }
                    })
                const url = window.URL.createObjectURL(new Blob([r.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `famille-action-sst.xlsx`); //or any other extension
                document.body.appendChild(link);
                link.click();
            } catch (err) {
                console.log(err)
            }
        }
    },
    data() {
        return {
            dataTable: [],
            typeInput: '',
            yearInput: '',
            phaseInput: '',
            dispositifInput: '',
            financeurInput: '',
            financeurInputSearch: '',
            departementInput: [],
            refResponsables: [],
            refFolders: [],
            responsableInput: '',
            folderInput: '',
            refFI: [],
            Reftype: ['Subvention', 'Subvention sans frais généraux', 'Prestation'],
            Refphase: [],
            Refyears: [],
            RefDepartement: [
                {lab: "Charente (16)", value: 16},
                {lab: "Charente-Maritime (17)", value: 17},
                {lab: "Corrèze (19)", value: 19},
                {lab: "Creuse (23)", value: 23},
                {lab: "Dordogne (24)", value: 24},
                {lab: "Gironde (33)", value: 33},
                {lab: "Landes (40)", value: 40},
                {lab: "Lot-et-Garonne (47)", value: 47},
                {lab: "Pyrénées-Atlantiques (64)", value: 64},
                {lab: "Deux-Sèvres (79)", value: 79},
                {lab: "Vienne (86)", value: 86},
                {lab: "Haute-Vienne (87)", value: 87},
                {lab: "Inter-région (99)", value: 99},
            ],
            RefDispositif: []
        }
    }
}
</script>

<style scoped>

.container {
    max-width: 100%;
    padding-left: 5%;
    padding-right: 5%;
}

</style>
